import React, { useState } from 'react';
import { Details } from './Details';
import { Messages } from './Messages';
import {
  Empty,
  PermissionCheck,
  Toggle,
  Card,
  Loading,
} from '../../../components';
import { filterMessagesWithInterruptions } from '../utils/utils';
import { PERMISSIONS } from '../../../shared/constants/permissions';
import type { SelfCostStatistics } from '../../../api';

export type ConversationProps = {
  agentId?: string;
  agentTitle: string;
  conversationId?: string;
  conversation: any;
  participant: any;
  messages: any[] | null;
  audio: any[] | null;
  loading?: boolean;
  selfCostStatistics?: SelfCostStatistics | null;
  loadingCostStatistics: boolean;
};

const Conversation: React.FC<ConversationProps> = ({
  conversation,
  participant,
  messages,
  audio,
  agentTitle,
  loading,
  selfCostStatistics,
  loadingCostStatistics,
}) => {
  const [showInterruptions, setShowInterruptions] = useState(false);
  const [showParallelSTT, setShowParallelSTT] = useState(false);

  return (
    <PermissionCheck
      action={PERMISSIONS.VIEW_CONVERSATIONS}
      fallback={<Empty message="No Access" />}
    >
      {loading ? (
        <Loading />
      ) : (
        <div className="flex flex-col lg:flex-row gap-y-lg lg:gap-x-lg">
          <Card
            withOverflow={false}
            size="unset"
            title="Transcribe"
            className="w-full lg:w-2/3 h-full"
            contentClassName="flex flex-col h-full"
          >
            <div className="flex flex-col sm:flex-row gap-md">
              <Toggle
                value={showInterruptions}
                onChange={() => setShowInterruptions(prev => !prev)}
                label="Show interruptions"
              />
              <Toggle
                value={showParallelSTT}
                onChange={() => setShowParallelSTT(prev => !prev)}
                label="Show Parallel STT"
              />
            </div>
            <Messages
              messages={filterMessagesWithInterruptions(
                messages ?? [],
                showInterruptions,
                showParallelSTT
              )}
              className="mt-lg mb-md"
            />
          </Card>

          <div className="w-full lg:w-1/3">
            <Details
              conversation={conversation}
              participant={participant}
              audio={audio || []}
              agentTitle={agentTitle}
              selfCostStatistics={selfCostStatistics}
              loadingCostStatistics={loadingCostStatistics}
            />
          </div>
        </div>
      )}
    </PermissionCheck>
  );
};

export default Conversation;
